import index from './pages/index'

const routes = [
    {
        path: '/technologies',
        name: 'Technology',
        component: index
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/technology/routes.js